<!-- 维权联系方式详情页面 -->
<template>
  <div class="contactDetail">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      {{name}}律师协会{{type === 'RPM' ? '维权' : '投诉'}}中心联系方式
    </div>
    <div class="detail-content">
      <el-card
        class="box-card"
        v-for="(item, index) in contactList"
        :key="index"
      >
        <div class="application-title">
          <img src="../assets/images/rect.png" alt="" />
          {{ item.name }}
        </div>
        <div class="detail-item">
          联系电话：<span>{{ item.mobile }}</span>
        </div>
        <div class="detail-item">
          联系邮箱：<span>{{ item.mail }}</span>
        </div>
        <div class="detail-item">
          来信来访地址：<span>{{ item.address }}</span>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      provinceId: "",
      type: "",
      name: "",
      code: "",
      codeUrl: "/captchacircle",
      contactList: [],
    };
  },
  created() {
    if (this.$route.params) {
      let { provinceId, type, name } = this.$route.params;
      this.provinceId = provinceId;
      this.type = type;
      this.name = name;
    }
    this.getOrgContactList();
  },
  methods: {
    getOrgContactList() {
      let params = {
        provinceId: this.provinceId,
        type: this.type,
      };
      api.getOrgContactList(params).then((res) => {
        if (res.data.code === 1) {
          this.contactList = res.data.result;
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    toIndex() {
      this.$router.push({
        name: "contactInformation",
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.contactDetail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f4f6fa;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .detail-content {
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 1rem;
    box-sizing: border-box;
    background: #f7f8fa;
    overflow: auto;
    .application-title {
      width: 100%;
      height: 2rem;
      font-weight: 500;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1rem;
      img {
        margin-right: 0.44rem;
        width: 0.38rem;
        height: 0.81rem;
      }
    }
    .box-card {
      margin-bottom: 1rem;
    }
    .detail-item {
      margin-bottom: 0.63rem;
      font-weight: 400;
      font-size: 0.88rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1.38rem;
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>